import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SubItem } from '../../../../components/Menu/components/SubItem/index.js';
import { Container } from '../../../../components/Menu/components/SubItemColumn/components/Container.js';
export const SubItemColumn = ({
  items
}) => _jsx(Container, {
  children: items.map((item, i) => _jsx(SubItem, {
    item: item
  }, i))
});